import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { runtime } from "@modern-js/plugin-v2/runtime";
import { merge } from "@modern-js/runtime-utils/merge";
import { compatPlugin } from "../compat";
import { handleSetupResult } from "../compat/hooks";
import { setGlobalInternalRuntimeContext } from "../context";
function registerPlugin(internalPlugins, runtimeConfig) {
  var _ref = runtimeConfig || {}, _ref_plugins = _ref.plugins, plugins = _ref_plugins === void 0 ? [] : _ref_plugins;
  var runtimeContext = runtime.run({
    plugins: [
      compatPlugin()
    ].concat(_to_consumable_array(internalPlugins), _to_consumable_array(plugins)),
    config: runtimeConfig || {},
    handleSetupResult
  }).runtimeContext;
  setGlobalInternalRuntimeContext(runtimeContext);
  return runtimeContext;
}
function mergeConfig(config) {
  for (var _len = arguments.length, otherConfig = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    otherConfig[_key - 1] = arguments[_key];
  }
  return merge.apply(void 0, [
    {},
    config
  ].concat(_to_consumable_array(otherConfig)));
}
export {
  mergeConfig,
  registerPlugin
};
